"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormCheckbox = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _KeyboardDetectionContext = require("../../contexts/KeyboardDetectionContext.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _index2 = require("../VisuallyHidden/index.js");
var _Checkbox = require("./Checkbox.js");
var _Indicator = require("./Indicator.js");
var _Label = require("./Label.js");
var _TextForLabel = require("./TextForLabel.js");
var _excluded = ["small", "size", "indeterminate", "id", "children", "semanticColor", "isHover", "isFocus", "isActive"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * FormCheckbox allow users to select one or more items from a set, turn an option on or off, or acknowlege something. Used within a Form component.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-formcheckbox--docs) |
 * [Encore site](https://encore.spotify.net/web/components/selectors#checkbox) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/FormCheckbox) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12297&t=uvnU5TzlyKmXuODT-1)
 */
var FormCheckbox = exports.FormCheckbox = /*#__PURE__*/_react["default"].forwardRef(function FormCheckbox(_ref, ref) {
  var small = _ref.small,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    indeterminate = _ref.indeterminate,
    id = _ref.id,
    children = _ref.children,
    _ref$semanticColor = _ref.semanticColor,
    semanticColor = _ref$semanticColor === void 0 ? 'essentialBrightAccent' : _ref$semanticColor,
    isHover = _ref.isHover,
    isFocus = _ref.isFocus,
    isActive = _ref.isActive,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useContext = (0, _react.useContext)(_KeyboardDetectionContext.KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  return /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.FormCheckbox
  }, /*#__PURE__*/_react["default"].createElement(_index2.VisuallyHidden, Object.assign({
    component: "input",
    type: "checkbox",
    ref: ref,
    id: id
  }, props)), /*#__PURE__*/_react["default"].createElement(_Label.Label, {
    htmlFor: id
  }, /*#__PURE__*/_react["default"].createElement(_Indicator.Indicator, {
    className: indeterminate ? 'Encore_indeterminate' : '',
    $indeterminate: indeterminate,
    $isUsingKeyboard: isUsingKeyboard,
    $semanticColor: semanticColor,
    $isHover: isHover,
    $isFocus: isFocus,
    $isActive: isActive
  }), children && /*#__PURE__*/_react["default"].createElement(_TextForLabel.TextForLabel, {
    className: small || size === 'small' ? (0, _index.textClass)('marginal') : (0, _index.textClass)('bodySmall'),
    $size: small ? 'small' : size
  }, children)));
});